export const normalizeDate = (date: Date | null) => {
  if (!date) return null;
  const dateObj = new Date(date);
  return new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate());
};
